import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AreaChartOutlined, KeyOutlined, PictureOutlined, RightOutlined, ScanOutlined, SettingOutlined } from "@ant-design/icons";
import { App, Layout, Menu, Spin } from "antd";
import $ from "jquery";
import { observer } from "mobx-react";
import { useCallback, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import Modal from "react-responsive-modal";
import { Provider as LicenseProvider } from "@devowl-wp/real-product-manager-wp-client";
import { AnalyseContent } from "./analyse.js";
import { ConfigLicensingConsumer } from "./licensing/consumer.js";
import { RegenerateContent } from "./regenerate.js";
import { SettingsContent } from "./settings.js";
import { SingleFileContent } from "./singleFile.js";
import { SingleFile } from "../models/singleFile.js";
import { useStores } from "../store/stores.js";
import { __ } from "../utils/i18n.js";
const { Sider, Content, Header } = Layout;
const Z_INDEX = 160001;
const MESSAGE_SUCCESSFUL_REGENERATION_KEY = "rtg-successful-regeneration";
/**
 * The dialog button opens and closes the dialog with tabs and content.
 *
 * It automatically creates a button in media library through ReactDOM.
 */ const DialogButton = observer(()=>{
    const { message } = App.useApp();
    const stores = useStores();
    const { statsStore, optionStore, attachmentsStore } = stores;
    const { unimplemented, others: { canManageOptions, showLicenseFormImmediate, isDevLicense } } = optionStore;
    const { regenerateBusy, analyzeBusy, singleBusy, single } = attachmentsStore;
    const [isOpen, setOpen] = useState(false);
    const [selectedTab, setSelectedTab] = useState("analyse");
    const doesCurrentlyProcess = isOpen && (regenerateBusy || analyzeBusy || singleBusy);
    const unloadText = __("Are you sure you want to cancel the current process?");
    const showLicenseFormImmediateCurrentUser = showLicenseFormImmediate && canManageOptions && !window.Playwright;
    const openSingleById = useCallback((id)=>{
        attachmentsStore.fetchSingle(id);
        setOpen(true);
        setSelectedTab("single");
    }, []);
    const handleSelect = useCallback(({ key })=>{
        const useKey = key;
        setSelectedTab(useKey);
        [
            "analyse",
            "generate"
        ].indexOf(useKey) > -1 && statsStore.fetch();
    // key === "single" && self.single && fetchSingle(self.single.id); // Refresh single
    }, [
        stores
    ]);
    const handleAnalyseItemClick = useCallback((e)=>openSingleById($(e.target).data().id || $(e.target).parents("li").data().id), []);
    /**
     * Create the buttons and listeners once for regeneration and dialog openers.
     */ useEffect(()=>{
        statsStore.fetch();
        // General "Thumbnails" button in media library
        const $body = $("body");
        if ($body.hasClass("wp-admin") && $body.hasClass("upload-php")) {
            const buttonPlaceholder = $("<span></span>").insertAfter($(".wp-heading-inline").next("a:last"));
            createRoot(buttonPlaceholder.get(0)).render(/*#__PURE__*/ _jsx("button", {
                className: "add-new-h2",
                onClick: ()=>setOpen(true),
                children: __("Regenerate Thumbnails")
            }));
        }
        // Listeners for "Info" in attachment detail / row
        $(document).on("click", 'button[data-rtg][data-action="info"]', function(e) {
            openSingleById(+$(this).data("rtg"));
            return e.preventDefault();
        });
        // Listeners for "Regenerate" in attachment detail / row
        $(document).on("click", 'button[data-rtg][data-action="regenerate"], a[data-rtg][data-action="regenerate"]', async function() {
            const $elem = $(this);
            $elem.prop("disabled", true).stop().fadeTo(100, 0.3);
            await new SingleFile({
                id: +$elem.data("rtg")
            }).regenerate(false, true);
            $elem.prop("disabled", false).stop().fadeTo(100, 1);
            message.destroy(MESSAGE_SUCCESSFUL_REGENERATION_KEY);
            message.success({
                key: MESSAGE_SUCCESSFUL_REGENERATION_KEY,
                content: __("Successfully regenerated image!")
            });
        });
        // Check hash and automatically open thumbnails dialog
        if (window.location.search.indexOf("thumbnails=true") > -1) {
            setOpen(true);
            window.history.replaceState({}, document.title, window.location.href.replace("thumbnails=true", ""));
        }
    }, []);
    return /*#__PURE__*/ _jsx(Modal, {
        open: isOpen,
        onClose: ()=>{
            if (doesCurrentlyProcess && window.confirm(unloadText) || !doesCurrentlyProcess) {
                setOpen(false);
            }
        },
        center: true,
        styles: {
            root: {
                zIndex: Z_INDEX
            },
            overlay: {
                zIndex: Z_INDEX
            },
            modal: {
                padding: 0,
                width: 1200,
                maxWidth: "initial",
                marginTop: 32,
                zIndex: Z_INDEX,
                height: "calc(100vh - 105px)"
            }
        },
        children: /*#__PURE__*/ _jsxs(Layout, {
            hasSider: true,
            style: {
                minHeight: "100%"
            },
            children: [
                /*#__PURE__*/ _jsxs(Sider, {
                    breakpoint: "lg",
                    collapsedWidth: "0",
                    children: [
                        /*#__PURE__*/ _jsx(Menu, {
                            theme: "dark",
                            mode: "inline",
                            selectedKeys: [
                                selectedTab
                            ],
                            onSelect: handleSelect,
                            items: [
                                {
                                    key: "analyse",
                                    disabled: regenerateBusy || showLicenseFormImmediateCurrentUser,
                                    icon: /*#__PURE__*/ _jsx(AreaChartOutlined, {}),
                                    label: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "nav-text",
                                                children: __("Analyze")
                                            }),
                                            /*#__PURE__*/ _jsx(Spin, {
                                                style: {
                                                    float: "right",
                                                    marginTop: 10
                                                },
                                                spinning: statsStore.busy && selectedTab === "analyse",
                                                size: "small"
                                            })
                                        ]
                                    })
                                },
                                {
                                    key: "generate",
                                    disabled: analyzeBusy || showLicenseFormImmediateCurrentUser,
                                    icon: /*#__PURE__*/ _jsx(ScanOutlined, {}),
                                    "data-id": "rtg-dialog-menu-item-regenerate",
                                    label: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "nav-text",
                                                children: __("Bulk regenerate")
                                            }),
                                            /*#__PURE__*/ _jsx(Spin, {
                                                style: {
                                                    float: "right",
                                                    marginTop: 10
                                                },
                                                spinning: statsStore.busy && selectedTab === "generate",
                                                size: "small"
                                            })
                                        ]
                                    })
                                },
                                {
                                    key: "single",
                                    disabled: showLicenseFormImmediateCurrentUser,
                                    icon: /*#__PURE__*/ _jsx(PictureOutlined, {}),
                                    label: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "nav-text",
                                                children: __("Single file")
                                            }),
                                            /*#__PURE__*/ _jsx(Spin, {
                                                style: {
                                                    float: "right",
                                                    marginTop: 10
                                                },
                                                spinning: singleBusy || !!single?.busy,
                                                size: "small"
                                            }),
                                            !single?.busy && single?.thumbnail && /*#__PURE__*/ _jsx("img", {
                                                className: "rtg-dialog-single-preview",
                                                src: single.thumbnail
                                            })
                                        ]
                                    })
                                },
                                canManageOptions && {
                                    key: "settings",
                                    disabled: showLicenseFormImmediateCurrentUser,
                                    icon: /*#__PURE__*/ _jsx(SettingOutlined, {}),
                                    "data-id": "rtg-dialog-menu-item-settings",
                                    label: /*#__PURE__*/ _jsx("span", {
                                        className: "nav-text",
                                        children: __("Settings")
                                    })
                                },
                                canManageOptions && {
                                    key: "license",
                                    disabled: showLicenseFormImmediateCurrentUser,
                                    icon: /*#__PURE__*/ _jsx(KeyOutlined, {}),
                                    label: /*#__PURE__*/ _jsx("span", {
                                        className: "nav-text",
                                        children: __("Licensing")
                                    })
                                }
                            ].filter(Boolean)
                        }),
                        unimplemented.length > 0 && /*#__PURE__*/ _jsx("div", {
                            className: "notice inline notice-error notice-alt",
                            style: {
                                margin: "0 0 10px"
                            },
                            children: /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    __("You have activated the plugin"),
                                    " ",
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: unimplemented.join(", ")
                                    }),
                                    ".",
                                    " ",
                                    __("The plugin influenced how thumbnails are generated or can cause costs for each newly generated thumbnail. Use the thumbnail regenerate feature with caution!"),
                                    "."
                                ]
                            })
                        }),
                        isDevLicense && /*#__PURE__*/ _jsx("div", {
                            className: "notice inline notice-warning notice-alt",
                            style: {
                                margin: "0 0 10px"
                            },
                            children: /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    __("Product license not for production use!"),
                                    " (",
                                    /*#__PURE__*/ _jsx("a", {
                                        href: __("https://devowl.io/knowledge-base/license-installation-type/"),
                                        rel: "noreferrer",
                                        target: "_blank",
                                        children: __("Learn more")
                                    }),
                                    ")"
                                ]
                            })
                        })
                    ]
                }),
                showLicenseFormImmediateCurrentUser ? /*#__PURE__*/ _jsx(LicenseProvider, {
                    children: /*#__PURE__*/ _jsx("div", {
                        style: {
                            padding: "30px 20px"
                        },
                        children: /*#__PURE__*/ _jsx(ConfigLicensingConsumer, {})
                    })
                }) : /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        selectedTab === "analyse" && /*#__PURE__*/ _jsx(AnalyseContent, {
                            onClick: handleAnalyseItemClick
                        }),
                        selectedTab === "generate" && /*#__PURE__*/ _jsx(RegenerateContent, {
                            onClick: handleAnalyseItemClick
                        }),
                        selectedTab === "single" && /*#__PURE__*/ _jsx(SingleFileContent, {}),
                        selectedTab === "settings" && !!canManageOptions && /*#__PURE__*/ _jsx(SettingsContent, {}),
                        selectedTab === "license" && !!canManageOptions && /*#__PURE__*/ _jsx(LicenseProvider, {
                            children: /*#__PURE__*/ _jsxs(Layout, {
                                children: [
                                    /*#__PURE__*/ _jsxs(Header, {
                                        style: {
                                            background: "#fff"
                                        },
                                        children: [
                                            __("Thumbnails"),
                                            " ",
                                            /*#__PURE__*/ _jsx(RightOutlined, {}),
                                            " ",
                                            __("Licensing")
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Content, {
                                        style: {
                                            margin: "24px 16px 0"
                                        },
                                        children: /*#__PURE__*/ _jsx(ConfigLicensingConsumer, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
});
export { DialogButton };
